"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeDrawUtil = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var model_1 = require("../model");
var unit_1 = require("../unit");
var IkeDrawUtil = /** @class */ (function () {
    function IkeDrawUtil() {
    }
    IkeDrawUtil.getBaseOffsetLabelText = function (capture, marker) {
        var labelText = marker.label.text;
        if (marker.y > capture.resolution.height) {
            return ['↓ ' + labelText];
        }
        return labelText;
    };
    IkeDrawUtil.getBaseLabelText = function (marker, options) {
        var units = options.units;
        var labelText = marker.label.text;
        var textLines = [];
        if (labelText.length > 0) {
            textLines = textLines.concat(labelText);
        }
        var offset = marker.offset;
        if (offset && offset > 0) {
            var offsetText = unit_1.IkeUnit.display(offset, units, unit_1.IkeUnit.METER);
            return ["".concat(offsetText, " - ").concat(textLines[0])];
        }
        return textLines;
    };
    IkeDrawUtil.getMarkerLabelText = function (capture, marker, options) {
        var e_1, _a, e_2, _b, e_3, _c;
        var _d;
        var units = options.units;
        var isInsightMarker = marker.insight && !marker.insight.applied;
        var isInsightMarkerLabelsVisible = options.isInsightMarkerLabelsVisible;
        var detection_class = (_d = marker.insight) === null || _d === void 0 ? void 0 : _d.detection_class;
        if (marker.type === core_api_1.MarkerType.BASE) {
            return IkeDrawUtil.getBaseLabelText(marker, options);
        }
        if (marker.type === core_api_1.MarkerType.BASE_OFFSET) {
            return IkeDrawUtil.getBaseOffsetLabelText(capture, marker);
        }
        var label = marker.label;
        var labelLinks = label.links;
        var output = [];
        if (labelLinks.length > 0) {
            var outputText = {};
            try {
                for (var labelLinks_1 = tslib_1.__values(labelLinks), labelLinks_1_1 = labelLinks_1.next(); !labelLinks_1_1.done; labelLinks_1_1 = labelLinks_1.next()) {
                    var link = labelLinks_1_1.value;
                    link.distanceUnit = units;
                    var title = link.annotationLabel;
                    outputText[title] = (outputText[title] || 0) + 1;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (labelLinks_1_1 && !labelLinks_1_1.done && (_a = labelLinks_1.return)) _a.call(labelLinks_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            try {
                // Squash text into a single line
                for (var _e = tslib_1.__values(Object.keys(outputText)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var textString = _f.value;
                    var count = outputText[textString];
                    if (count < 2) {
                        output.push(textString);
                    }
                    else {
                        output.push("".concat(count, "x ").concat(textString));
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        try {
            for (var _g = tslib_1.__values(label.text), _h = _g.next(); !_h.done; _h = _g.next()) {
                var text = _h.value;
                output.push(text);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_h && !_h.done && (_c = _g.return)) _c.call(_g);
            }
            finally { if (e_3) throw e_3.error; }
        }
        if (isInsightMarker && isInsightMarkerLabelsVisible && detection_class && !(0, model_1.isInsightOffsetDetectionClass)(detection_class || '')) {
            output.push(detection_class);
        }
        // The test (output.length == 2) is only valid if one of them is the marker value.
        // This assumption is not guaranteed anymore with the detection class.
        // This part of the code might eventually require a refactor, if more if statements are added in the future.
        if (marker.value) {
            output.push(unit_1.IkeUnit.display(marker.value, units, unit_1.IkeUnit.METER));
            if (output.length === 2) {
                return ["".concat(output[1], " - ").concat(output[0])];
            }
        }
        return output;
    };
    IkeDrawUtil.getLineLabelText = function (line, options) {
        var units = options.units;
        var output = line.label.text.slice();
        output.push(unit_1.IkeUnit.display(line.value, units, unit_1.IkeUnit.METER));
        if (output.length === 2) {
            return ["".concat(output[1], " - ").concat(output[0])];
        }
        return output;
    };
    return IkeDrawUtil;
}());
exports.IkeDrawUtil = IkeDrawUtil;
//# sourceMappingURL=draw.util.js.map